import React, { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const ChatIcon: FC<Omit<SvgIconProps, 'viewBox'>> = ({ ...iconProps }) => (
  <SvgIcon {...iconProps} viewBox="0 0 21 19">
    <path
      d="M10.2857 0C4.60491 0 0 3.70933 0 8.28438C0 10.1453 0.771429 11.857 2.05714 13.2395V18.6398L7.02823 16.138C8.05269 16.4134 9.14606 16.5688 10.2857 16.5688C15.9665 16.5688 20.5714 12.8594 20.5714 8.28438C20.5714 3.70933 15.9665 0 10.2857 0Z"
      fill="#484848"
    />
  </SvgIcon>
);
export default ChatIcon;
